import React from 'react';
import ShowHideCell from './ShowHideCell';
import NameCell  from './NameCell';
import ProjectRoleCell from './ProjectRoleCell';
import {
    MyTableCell1,
} from "../../../../styling/Styles";
import StatusCell from './StatusCell';
import ProjectActionsCell from './ProjectActionsCell';
import ProjectQualityCell from './ProjectQualityCell';

/**
 * This component returns all the cells of a row that belongs to 
 * home's projects table.
 */
const ProjectsTableRowCells = (props) => {

    const{
        row,
        index,
        projectRole,
        setProjectRole,
        showStatus,
        setShowStatus,
        updateData,
        setUpdateData,
        status,
        setStatus,
        setPressVisibilityButton,
        response,
        hiddenProjects,
        setHiddenProjects,
        activeProjects,
        setActiveProjects,
        setDisplayKickedOutMessage
    } = props;

    return(
        <>
            <ShowHideCell row={row} index={index}  showStatus={showStatus} setShowStatus = {setShowStatus} setPressVisibilityButton={setPressVisibilityButton} response={response} hiddenProjects={hiddenProjects} setHiddenProjects={setHiddenProjects}/>
            <NameCell row={row} index={index} showStatus={showStatus} projectRole={projectRole} setDisplayKickedOutMessage={setDisplayKickedOutMessage}/>
            <BasicCell label={row.date} index={index} showStatus={showStatus} />
            <ProjectRoleCell row ={row} index={index} updateData={updateData} projectRole={projectRole} setProjectRole={setProjectRole} showStatus = {showStatus}/>
            <BasicCell label={row.pages.length} index={index} showStatus={showStatus} />
            <ProjectQualityCell projectName={row.name} label={row.projectQuality !== undefined && row.projectQuality.backEndQualityData !== undefined && row.projectQuality.backEndQualityData.overallQualityScore !== undefined  ? row.projectQuality.backEndQualityData.overallQualityScore : 0} index={index} showStatus={showStatus} reason='server' />
            <ProjectQualityCell projectName={row.name} label={row.projectQuality !== undefined && row.projectQuality.frontEndQualityData !== undefined && row.projectQuality.frontEndQualityData.overallQualityScore !== undefined ? row.projectQuality.frontEndQualityData.overallQualityScore : 0} index={index} showStatus={showStatus} reason='front'/>
            <StatusCell row={row} index={index} status={status} setStatus={setStatus} showStatus = {showStatus} activeProjects={activeProjects} setActiveProjects={setActiveProjects}/>
            <ProjectActionsCell row={row} index={index} setUpdateData={setUpdateData} projectRole ={projectRole} showStatus = {showStatus}/>
        </>
    )

}

//  This component returns a basic cell that belongs to a row inside home's projects table.
const BasicCell = ({label, index,showStatus}) => 
    (
        <MyTableCell1
            align="center"
            style={
                index % 2 === 0
                ? null
                : { backgroundColor: "#CFD8E0" }
            }
            >
                <span style={showStatus === false ? {color: '#999999'}: null}>{label}</span>
        </MyTableCell1>
)


export default ProjectsTableRowCells;
export {
    BasicCell
}